import React, { FC } from 'react'
import { useSelector } from 'react-redux'

import { olympiadsSelectors } from '@ucheba/store/institutions/olympiads'

import { Heading } from '@ucheba/ui/components/Heading/desktop'

import IconInfo from '@ucheba/ui/icons/icon__info.svg'

import { Banner } from '../../../../../../components/Banner/desktop'
import LayoutInstitution from '../../../../../../components/LayoutInstitution/desktop'

import { Title, TooltipStyled } from '../styled'
import EmptyListPlaceholder from '../../../../components/EmptyListPlaceholder'
import ListOlympiads from './ListOlympiads'
import { useBannerProgramTypes } from '../../utils/useBannerProgramTypes'
import { isPaidPackage } from '../../utils/isPaidPackage'

const InstitutionOlympiadsPage: FC = () => {
  const olympiads = useSelector(olympiadsSelectors.entity)

  const { extraParams, paidPackage } = useBannerProgramTypes()

  return (
    <>
      <LayoutInstitution>
        {!olympiads?.total ? (
          <>
            <Title>
              <Heading as='h1' h2='Олимпиады вуза' spacing='null' />

              <TooltipStyled
                width='553px'
                position='right-center'
                content='Победители и призеры этих олимпиад имеют льготы при поступлении'
              >
                <IconInfo />
              </TooltipStyled>
            </Title>

            <EmptyListPlaceholder
              link='/for-abiturients/olympiads'
              title='Этот вуз не проводит олимпиады'
              linkText='Посмотреть олимпиады в других вузах'
            />
          </>
        ) : (
          <ListOlympiads />
        )}
      </LayoutInstitution>

      {!isPaidPackage(paidPackage) && <Banner id={6} extraParams={extraParams} />}

      {!isPaidPackage(paidPackage) && <Banner id={14} extraParams={extraParams} />}
    </>
  )
}

export default InstitutionOlympiadsPage
